"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Testimonial = function (_a) {
    var logo = _a.logo, link = _a.link, title = _a.title;
    return (react_1.default.createElement("a", { className: styles_module_scss_1.default.container, href: link, target: "_blank", rel: "noopener" },
        react_1.default.createElement("img", { src: logo, alt: title })));
};
exports.default = Testimonial;
